import React, { useState } from 'react';
import { Box, IconButton, CardMedia, Typography, Container, List, ListItem, ListItemText, ListItemIcon } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import slider1 from '../img-landing/slider/carousel.png'
import slider2 from '../img-landing/slider/carousel2.jpg'
import slider3 from '../img-landing/slider/carousel3.jpg'
import slider4 from '../img-landing/slider/carousel4.jpg'
import CheckIcon from '@mui/icons-material/Check';

const images = [
    { id: "1", image: slider1, label: 'Video Services ', value: "Shoot, Share, and Scale—high-impact video content through expert production, UGC, and AI solutions.", list: [{ value: 'Video Production – Shoot & Edit ' }, { value: 'UGC (User-Generated Content) ' }, { value: 'AI-Generated Content ' }] },
    {
        id: "2", image: slider2, label: 'Video Production – Shoot & Edit', value: 'Reels, events, and promos shot and edited in-house.', list: [{ value: 'Reel Production ' }, { value: 'Product Shoots' }, { value: 'Event Coverage ' },
        { value: 'Testimonial Videos ' }, { value: 'Explainer Videos ' }, { value: 'Demo & Solution Videos ' }, { value: 'Podcast & Audio Content ' }, { value: 'Promotional & Creative Ads  ' }]
    },
    { id: "3", image: slider3, label: 'UGC (User-Generated Content)', value: "Real voices, real results—content that connects and converts. " },
    { id: "4", image: slider4, label: 'AI-Generated Content', value: "AI-powered video solutions to scale campaigns faster with next-gen tech. " },
];


const Experties = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        if (currentIndex < images.length - 1) {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prevIndex) => prevIndex - 1);
        }
    };

    return (
        <Box className='containerbgColor py80 mt-3'>
            <Container className='p-0 mobilepadding'>
                <Box className='displayStyle1'>
                    <Box>
                        <Typography variant="h4" className='font600 fontSize40' gutterBottom>
                            Our Expertise
                        </Typography>
                        <Typography variant="body1" paragraph className='fontSize18 font400 lineHeight'>
                            Tailored Video Services That Enhance Your Brand's Digital Footprint
                        </Typography>
                    </Box>

                </Box>
                <Box display="flex" alignItems="center" mt={5} position={'relative'} >
                    <Box display="flex" overflow="hidden" width="100%">
                        <Box display="flex"
                            sx={{
                                transform: `translateX(-${currentIndex * 100}%)`,
                                transition: 'transform 0.5s ease',
                                width:'100%'
                            }}>
                            {images.map((img, index) => (
                                <Box key={index} className='boxshadownone borderRadius displayStyle expertiesMobile' sx={{ minWidth: '100%', gap: '25px', padding: '0px 25px' }}>
                                    <CardMedia component="img" image={img.image} alt={`Image ${index + 1}`}  sx={{
                                        width: '100%',
                                        height: 340,
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                    }} />
                                    <Box className='w-100'>
                                        <Typography className='font600 fontSize27' sx={{ color: '#898989' }}>{img.label}</Typography>
                                        <Typography className='font400 fontSize18 lineHeight' mt={2}>{img.value}</Typography>
                                        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                                            <List>
                                                {img?.list?.slice(0, 3).map((d, idx) => (
                                                    <ListItem key={`first-${idx}`}>
                                                        <ListItemIcon sx={{ minWidth: '35px' }}>
                                                            <CheckIcon sx={{ fontSize: '20px' }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary={d?.value} />
                                                    </ListItem>
                                                ))}

                                            </List>
                                            <List>
                                                {img?.list?.slice(3, 6).map((d, idx) => (
                                                    <ListItem key={`second-${idx}`}>
                                                        <ListItemIcon sx={{ minWidth: '35px' }}>
                                                            <CheckIcon sx={{ fontSize: '20px' }} />
                                                        </ListItemIcon>
                                                        <ListItemText primary={d?.value} />
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Box>
                                    </Box>
                                </Box>
                            ))}

                        </Box>
                    </Box>
                    <Box className='displayStyle justifySpacebtw expertiesBtnMobile' position={'absolute'} width={'100%'}  >
                        <IconButton className={'borderRadius100 slidbtn bgWhite'} onClick={handlePrev} disabled={currentIndex === 0}>
                            <ArrowBackIcon sx={{ fontSize: '20px' }} />
                        </IconButton>
                        <IconButton className={'borderRadius100 slidbtn bgWhite'} onClick={handleNext} disabled={currentIndex === images.length - 1}>
                            <ArrowForwardIcon sx={{ fontSize: '20px' }} />
                        </IconButton>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Experties;
